module.exports = __webpack_public_path__ + "static/img/aa-2.055c375.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aa-2.png
// module id = eYNC
// module chunks = 1